// extracted by mini-css-extract-plugin
export default {"sectionTabShoab":"style_sectionTabShoab__+kmi0","tabBtn":"style_tabBtn__A6owT","btnTabs":"style_btnTabs__KdZAr","btnTabsActive":"style_btnTabsActive__MSSj8"};